/*=========================================================================================
  File Name: moduleCategoryState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	visitPoints: [],
	visitPointsDatarutas: [],
	visitPointsPickup: [],
	visitPointsDelivery: [],
	assignedVisitPoints: [],
	currentVisitPoint: {},
	currentVisitPointId: 0,
	checkedVisitPoits: [],
	checkedVisitPoitsPickup: [],
	checkedVisitPoitsDelivery: [],
	checkedVisitPoitsPickupDatarutas: [],
	checkedVisitPoitsDeliveryDatarutas: [],
	checkedVisitPoitsDatarutas: [],
	uploadFileVisitPointsOptimization: [],
	checkedUploadFileVisitPoitsPickup: [],
	checkedUploadFileVisitPoitsDelivery: [],
	pagination: {
		next_page: 0,
		total_pages: 0,
		total_records: 0,
	},
};
